import { type Node } from '@xyflow/react';

export const isDescendantOfUnit = (nodes: Node[], nodeId: string, ancestorId: string): boolean => {
  const currentNode = nodes.find((candidate) => candidate.id === nodeId);

  if (!currentNode || !currentNode.parentId) {
    return false;
  }

  if (currentNode.parentId === ancestorId) {
    return true;
  }

  if (!currentNode.parentId.startsWith('unit_')) {
    return false;
  }

  return isDescendantOfUnit(nodes, currentNode.parentId, ancestorId);
};

export const hasAIMetadata = (value: unknown): boolean => value !== undefined && value !== null;
